module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_0.8749d077.png";